import React from 'react'
import PageForm from '../form'

const RefundPolicy = () => {
  return <PageForm title="Refund Policy" Key="refund-policy" />
}

export default RefundPolicy
